import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchReviews = createAsyncThunk('ReviewsSlice/fetchReviews', async () => {
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?reviews`)
    const data = await res.json()
    return data;
})

const reviewsSlice = createSlice({
    initialState: {
        reviews: [],
        loading: false,
        error: null,
    },
    name: 'ReviewsSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchReviews.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchReviews.fulfilled, (state, action) => {
                state.loading = false;
                state.reviews = action.payload;
            })
            .addCase(fetchReviews.rejected, (state, action) => {
                state.loading = false;
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

export const { } = reviewsSlice.actions;

export default reviewsSlice.reducer;